import { AfterContentInit, Component, Inject, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { Role } from "../../auth/roles";
import { UserRoleService } from "../../auth/user-role-service";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { toggleDisplayReducerFactory } from "./reducer";
import { TOGGLE_DISPLAY_STATE_PROP } from "./state-props";

@Component({
    selector: "common-toggle-display",
    templateUrl: "./common-toggle-display.component.html",
    exportAs: "CommonToggleDisplayContext",
})
export class CommonToggleDisplayComponent implements AfterContentInit, OnDestroy {
    @Input() public stateProp: string;
    @Input() public selectedIndex = 0;

    private state$: Subscription;
    public initialState = {
        selectedIndex: this.getInitialTabIndex(),
    };

    constructor(
        private ngRedux: ImmutableRedux<any>,
        private userRoleService: UserRoleService,
        @Inject(TOGGLE_DISPLAY_STATE_PROP) public rootProp,
    ) { }

    getInitialTabIndex(): number {
        return this.userRoleService.hasRoles([Role.CUSTOMER_CONTACTS_READER]) ? 0 : 1;
    }

    public ngAfterContentInit() {
        this.ngRedux.registerComponent(toggleDisplayReducerFactory, this.rootProp, this.stateProp, this.initialState);
        this.state$ = this.ngRedux.select(this.rootProp, this.stateProp).subscribe((state) => {
            if (state.selectedIndex) { this.selectedIndex = state.selectedIndex; }
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }
}
